import { ContentfulMedia, parseSectionItem } from '@wbk/contentful';
import { WebSection } from '@wbk/contentful/api';
import { Button, Typography } from '@wbk/ui';
import useLocalization from '@/context/localization/useLocalization';
import useZonesContext from '@/context/zones/useZones';
import { Carousel } from '@/components/ui/Carousel';

const CountriesCard: React.FC<{ section: WebSection }> = ({ section }) => {
  const { locale } = useLocalization();

  const { targetRef, setSelectedAnchorCard } = useZonesContext();

  return (
    <div className='container-padding container'>
      <section className='container px-3 lg:space-y-12 xl:px-0'>
        <div className='space-y-8'>
          <Carousel
            rootClassName='box-border h-full flex mb-10 w-full flex-1  rounded-2xl'
            containerClassName='h-full gap-4'
            dots
            autoplay={{ delay: 5000, stopOnInteraction: false }}
            className='w-full'
          >
            {section.contentCollection?.items?.map((item, index) => {
              const parsedItem = parseSectionItem({ item, locale });

              if (!parsedItem) return null;

              const parsed = parsedItem;

              return (
                <Button
                  theme='white'
                  shape='text'
                  className='h-full shrink-0 basis-[43%] object-cover p-0 hover:bg-transparent sm:basis-[40%] md:basis-[43%] lg:basis-[33%] xl:basis-[23%]'
                  key={index}
                  onClick={() => {
                    setSelectedAnchorCard?.(item);
                    targetRef?.current?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <div className='group relative w-full overflow-hidden rounded-2xl md:rounded-3xl dark:bg-black dark:text-[#F4F4F5]'>
                    <div className='group relative h-64 md:h-[26rem]'>
                      <ContentfulMedia
                        media={parsedItem?.image11}
                        className='h-full w-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110'
                      />

                      <div className='absolute inset-x-0 bottom-0 flex flex-col items-start gap-1 p-2 backdrop-blur-[1px] sm:p-4'>
                        <div className='flex w-full flex-col items-start gap-2'>
                          <ContentfulMedia
                            media={parsedItem?.image31}
                            className='w-20 object-cover transition-transform duration-300 ease-in-out group-hover:scale-110 md:w-36'
                          />

                          <Typography
                            variant='body-XXS'
                            className='md:text-body-XS text-start text-white'
                          >
                            {parsed.subtitle}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </Button>
              );
            })}
          </Carousel>
        </div>
      </section>
    </div>
  );
};

export default CountriesCard;
